import { Button, withConfirmation } from '@frontendmentorio/design-system-v2';

const ConfirmButton = withConfirmation(Button);

export default ConfirmButton;
